const dropdownBtn = document.getElementById("search-dropdown");
const dropdownMenu = document.querySelector(".search-facets ul.dropdown-menu") as HTMLUListElement;

if (dropdownBtn) {
	dropdownBtn.addEventListener("click", e => {
		e.preventDefault();
		dropdownMenu.classList.add("show");
	});
}

document.addEventListener("click", (e) => {
    if ((e.target as HTMLElement).closest("#search-dropdown") !== null) {
		e.preventDefault();
    } else if (dropdownMenu) {
		dropdownMenu.classList.remove("show");
    }    
});
